import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import auditLogService from "@/services/api/auditLog";
import type { AuditLogEntry, GetActionLogsParams } from "@/services/api/auditLog";

export interface AuditLogState {
  entries: AuditLogEntry[];
  totalEntries: number;
  isFetching: boolean;
  error: string | null;
}

const initialState: AuditLogState = {
  entries: [],
  totalEntries: 0,
  isFetching: false,
  error: null,
};

export const getActionLogs = createAsyncThunk(
  "auditLog/getActionLogs",
  async (params: GetActionLogsParams | undefined) => auditLogService.getActionLogs(params),
);

const auditLogSlice = createSlice({
  name: "auditLog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getActionLogs.pending, (state) => {
        state.isFetching = true;
        state.error = null;
      })
      .addCase(getActionLogs.fulfilled, (state, action) => {
        state.isFetching = false;
        state.entries = action.payload?.data?.results ?? [];
        state.totalEntries = action.payload?.data?.totalRecord ?? state.entries.length;
      })
      .addCase(getActionLogs.rejected, (state, action) => {
        state.isFetching = false;
        state.entries = [];
        state.error = action.error.message ?? "Failed to load audit log";
      });
  },
});

export default auditLogSlice.reducer;
